






















































































































import Component from 'vue-class-component';
import BeastComponent from './beast.vue';
import Vue from 'vue';
import { Beast } from '@/interfaces/world/beast';
import FirebaseGateway from '@/classes/firebaseGateway';
import TalentCollection from '../../../classes/attributes/talentCollection';
import { Watch } from 'vue-property-decorator';

@Component({
  components: { BeastComponent },
})
export default class Bestiary extends Vue {
  private loading = true;

  private newFile: File | null = null;
  private previewUrl: string | null = null;
  private saveBeast = false;
  private showCreateDialog = false;
  private showDeleteDialog = false;
  private groupView = false;
  private beastTypeFilter: string = '';

  private newBeast: Beast = {
    id: null,
    description: '',
    imageUrl: null,
    createdBy: null,
    hideImage: false,
    classMargins: [null, null, null, null, null],
    name: '',
    type: '',
    location: '',
    values: [],
  };

  private enemyClasses = ['Todgeweiht', 'Schwertfutter', 'Erfahren', 'Elite', 'Held'];

  get allTalents() {
    const talentCollection = new TalentCollection();
    return talentCollection.allTalents
      .map((talent) => {
        return { text: talent.name, value: talent.abbreviation };
      })
      .sort((talentA, talentB) => (talentA.text < talentB.text ? -1 : 1));
  }

  get beasts(): Beast[] {
    let beasts = this.$store.getters.beasts as Beast[];
    if (typeof this.beastTypeFilter !== 'undefined' && this.beastTypeFilter !== '') {
      beasts = beasts.filter((beast) => beast.type === this.beastTypeFilter);
    }
    return beasts;
  }

  get beastsSorted(): Beast[] {
    return this.beasts.sort((beastA, beastB) => (beastA.name < beastB.name ? -1 : 1));
  }

  get beastTypes() {
    return this.beasts
      .map((beast) => beast.type)
      .filter((value, index, self) => self.indexOf(value) === index)
      .sort((typeA, typeB) => (typeA < typeB ? -1 : 1));
  }

  get locations() {
    return this.beasts
      .map((beast) => beast.location)
      .filter((value, index, self) => self.indexOf(value) === index && typeof value !== 'undefined')
      .sort((typeA, typeB) => (typeA < typeB ? -1 : 1));
  }

  get currentWorld(): string {
    return this.$store.getters.currentWorld;
  }

  get isWorldEditorOrAdmin(): string {
    return this.$store.getters.isWorldEditor(this.currentWorld);
  }

  get currentUser(): string {
    return this.$store.getters.userId;
  }

  public mounted() {
    this.loading = true;
    const worldPromise = this.$store.dispatch('loadWorlds');
    const beastPromise = this.$store.dispatch('loadBeasts');

    // When both promises are finished, loading is done
    const loadingPromise = Promise.all([worldPromise, beastPromise]);
    loadingPromise.then(() => {
      this.loading = false;
    });
  }

  private onCreateBeastClick() {
    this.saveBeast = true;
    // give the forms a little time to process blur events
    setTimeout(this.createBeast, 150);
  }

  private createBeast() {
    this.newBeast.createdBy = this.$store.getters.userId;
    const beast = JSON.parse(JSON.stringify(this.newBeast));
    if (this.newFile !== null) {
      this.uploadFile(this.newFile);
    } else {
      this.$store.dispatch('createBeast', beast).then(() => {
        this.saveBeast = false;
        this.resetDialog();
      });
    }
  }

  private uploadFile(file: File) {
    const firebaseGateway = new FirebaseGateway();
    firebaseGateway
      .uploadFile(file, '/worlds/' + this.currentWorld + '/beasts/')
      .then((downloadUrl) => {
        this.newBeast.imageUrl = downloadUrl;
        this.$store.dispatch('createBeast', this.newBeast).then(() => {
          this.saveBeast = false;
          this.resetDialog();
        });
      })
      .catch((error) => {
        this.saveBeast = false;
      });
  }

  private onFileChanged(file: File | undefined) {
    if (typeof file === 'undefined') {
      this.previewUrl = null;
      return;
    }
    const fr = new FileReader();
    fr.readAsDataURL(file);
    fr.addEventListener('load', () => {
      this.previewUrl = fr.result as string;
    });
  }

  private onEditBeast(beast: Beast) {
    const beastCopy: Beast = JSON.parse(JSON.stringify(beast));
    if (typeof beastCopy.classMargins === 'undefined') {
      beastCopy.classMargins = [null, null, null, null, null];
    }
    this.newBeast = beastCopy;
    this.previewUrl = beastCopy.imageUrl;
    this.showCreateDialog = true;
  }

  private onDeleteBeast(beast: Beast) {
    this.showDeleteDialog = true;
  }

  private resetDialog() {
    this.newBeast = {
      id: null,
      createdBy: '',
      description: '',
      imageUrl: null,
      classMargins: [null, null, null, null, null],
      name: '',
      type: '',
      location: '',
      hideImage: false,
      values: [],
    };
    this.newFile = null;
    this.previewUrl = null;
    this.showCreateDialog = false;
  }

  private addBeastValue() {
    this.newBeast.values.push({ name: '', value: null, requirement: { talent: '', value: 0 } });
  }

  @Watch('groupView')
  private onGroupViewChange(isGroupView) {
    this.loading = true;
    const beastPromise = this.$store.dispatch('loadBeasts', isGroupView);
    beastPromise.finally(() => {
      this.loading = false;
    });
  }
}
